
    let newDate = new Date();
    let day = newDate.getDate();
    // let month = newDate.getMonth()+1;
    let year = newDate.getFullYear();
    let strDay = newDate.toLocaleDateString("en",{weekday:"short"})
    let strMonth = newDate.toLocaleDateString("en",{month:"short"})
    export const formatDate = `${strDay} , ${day} ${strMonth} ${year}`
    
